import config from './config.js'

export default {

  registry() {
    return fetch(config.baseUrl + 'rest/remoteservices/registry').then(resp => resp.json());
  },

  datatypes() {
    return fetch(config.baseUrl + 'rest/remoteservices/datatypes').then(resp => resp.json());
  },

  remove(key) {
    return fetch(config.baseUrl + 'rest/remoteservices/services/' + encodeURIComponent(key),{ method: 'DELETE' }).then(resp => resp.json());
  }

}
